import { NoteContent } from "../../../Components/NotesApp/NoteAppInterface";
export const EverestNoteContent: NoteContent[] = [
  {
    title: "Meet with Manuel in July",
    date: "11 May 2025",
    content: [
      {
        entry: "Meet with Manuel in July",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Nepal local Temex SIM Card",
    date: "17 April 2025",
    content: [
      {
        entry: "Nepal local Temex SIM Card",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Partridge Veterinary Services, 1042 Burroughs Drive",
    date: "9 April 2025",
    content: [
      {
        entry: "Partridge Veterinary Services, 1042 Burroughs Drive",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Le pigeon rouge restaurant - Kathmandu",
    date: "4 April 2025",
    content: [
      {
        entry: "Le pigeon rouge restaurant - Kathmandu",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Blue Platinum head torch",
    date: "21 March 2025",
    content: [
      {
        entry: "Blue Platinum head torch",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Don’t forget Darwin’s birthday present",
    date: "13 March 2025",
    content: [
      {
        entry: "Don’t forget Darwin’s birthday present",
      },
    ],
    locked: false,
    unclickable: true,
  },
];
